import React, { useState, useRef, useEffect } from "react";


const PartFirstTab = ({selectedAnswersPartI, setSelectedAnswersPartI}) => {
  
  const questionRefs = useRef([]);
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
    const handleAnswerChange = (questionNumber, option, answer) => {
      setSelectedAnswersPartI((prevAnswers) => {
        const newAnswers = { ...prevAnswers };
    
        if (questionNumber === 25) {
          if (newAnswers[questionNumber]?.includes(option)) {
            newAnswers[questionNumber] = newAnswers[questionNumber].filter((opt) => opt !== option);
          } else if ((newAnswers[questionNumber]?.length || 0) < 2) {
            newAnswers[questionNumber] = [...(newAnswers[questionNumber] || []), option];
          }
        } else {
          newAnswers[questionNumber] = newAnswers[questionNumber] === option ? null : option;
        }
    
        const nextQuestionIndex = questionNumber; 
        if (questionRefs.current[nextQuestionIndex]) {
          questionRefs.current[nextQuestionIndex].scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
    
        return newAnswers;
      });
    };
    
    

  const questions = [
    { id: 1, text: "When you go somewhere for the day, would you rather", options: ["Plan what you will do and when, or", "Just go?"] },
    { id: 2, text: "If you were a teacher, would you rather teach?", options: ["Fact courses, or", "Courses involving theory?"] },
    { id: 3, text: "Are you usually", options: ["A 'good mixer', or", "Rather quiet and reserved?"] },
    { id: 4, text: "Do you more often let", options: ["Your heart rule your head, or", "Your head rule your heart?"] },
    { id: 5, text: "In doing something that many other people do, does it appeal to you more to", options: ["Invent a way of your own, or", "Do it in the accepted way?"] },
    { id: 6, text: "Among your friends are you", options: ["Full of news about everybody, or", "One of the last to hear what is going on?"] },
    { id: 7, text: "Does the idea of making a list of what you should get done over a weekend", options: ["Appeal to you, or", "Leave you cold, or", "Positively depress you?"] },
    { id: 8, text: "When you have a special job to do, do you like to", options: ["Organize it carefully before you start, or", "Find out what is necessary as you go along?"] },
    { id: 9, text: "Do you tend to have", options: ["Broad friendships with many different people, or", "Deep friendship with very few people?"] },
    { id: 10, text: "Do you admire more the people who are", options: ["Conventional enough never to make themselves conspicuous, or", "Too original and individual to care whether they are conspicuous or not?"] },
    { id: 11, text: "Do you prefer to", options: ["Arrange picnics, parties, etc., well in advance, or", "Be free to do whatever looks like fun when the time comes?"] },
    { id: 12, text: "Do you usually get along better with", options: ["Realistic people, or", "Imaginative people?"] },
    { id: 13, text: "When you are with a group of people, would you usually rather", options: ["Join in the talk of the group or", "Imaginative people?"] },
    { id: 14, text: "Is it a higher compliment to be called", options: ["A person of real feeling, or", "A consistently reasonable person?"] },
    { id: 15, text: "In reading for pleasure, do you", options: ["Enjoy odd or original ways of saying things, or", "Like writers to say exactly what they mean?"] },
    { id: 16, text: "Do you", options: ["Talk easily to almost anyone for as long as you have to, or", "Find a lot to say only to certain people or under certain conditions?"] },
    { id: 17, text: "Does following a schedule", options: ["Appeal to you, or", "Cramp you?"] },
    { id: 18, text: "When it is settled well in advance that you will do a certain thing at a certain time, do you find it", options: ["Nice to be able to plan accordingly, or", "A little unpleasant to be tied down?"] },
    { id: 19, text: "Are you more successful", options: ["At following a carefully worked-out plan, or", "At dealing with the unexpected and seeing quickly what should be done?"] },
    { id: 20, text: "Would you rather be considered", options: ["A practical person, or", "An ingenious person?"] },
    { id: 21, text: "In a large group, do you more often", options: ["Introduce others, or", "Get introduced?"] },
    { id: 22, text: "Do you usually", options: ["Value sentiment more than logic, or", "Value logic more than sentiments?"] },
    { id: 23, text: "Would you rather have as a friend", options: ["Someone who is always coming up with new ideas, or", "Someone who has both feet on the ground?"] },
    { id: 24, text: "Can the new people you meet tell what you are interested in", options: ["Right away, or", "Only after they really get to know you?"] },
    { id: 25, text: "(On this question only, if two answers are true, circle both) In your daily work, do you", options: ["Usually plan your work so you won’t need to work under pressure, or", "Rather enjoy an emergency that makes you work against time, or", "Hate to work under pressure?"] },
    { id: 26, text: "Do you usually", options: ["Show your feelings freely, or", "Keep your feelings to yourself?"] }
  ];
  

  return (
    <div className="container mx-auto justify-center items-center px-6 py-8">
      <h1 className="parts pl-24 pr-24 question-header text-gray-800 text-left mb-12">
        Please answer these statements as authentically as possible. There is no right or wrong response.
      </h1>
      
      <div className=" parts pl-24 pr-24 text-gray-800   ">
      {questions.map((question, index) => (
        <div
          key={question.id}
          ref={(el) => (questionRefs.current[index] = el)}
          className="p-6 mb-6 bg-white shadow-lg "
        >
          <h2 className="question-text text-gray-700 mb-4">
            Question {question.id}: {question.text}
          </h2>
          
          <div
            className={`grid ${
              question.options.length === 3
                ? "grid-cols-2 gap-1"
                : ""
            }`}
          >
            {question.options.map((option, optionIndex) => {
        const optionLabel = String.fromCharCode(65 + optionIndex);

              return(

                <div
                className="mb-6"
              >

<button
  key={optionIndex}
  onClick={() => handleAnswerChange(question.id, optionLabel, option)}
  className={`text-left py-3 px-6 option-text rounded-lg focus:outline-none transition duration-200 ${
    question.id === 25
      ? selectedAnswersPartI[question.id]?.includes(optionLabel)
        ? "bg-green-500 text-white"
        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
      : selectedAnswersPartI[question.id] === optionLabel
      ? "bg-green-500 text-white"
      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
  }`}
>
  {optionIndex + 1}. {option}
</button>

              </div>
              
              )
})}
          </div>
        </div>
      ))}      

      </div>
    </div>
  );
};

export default PartFirstTab;
